import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function queryInvoiceByAppointmentIds(
  appointmentId,
  onBehalfOf?: string,
) {
  const res = await fetchOrchidAPI(
    `/api/invoicing/get_by_appointment_ids${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "POST",
      body: JSON.stringify({
        appointment_ids: [appointmentId],
      }),
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to get invoice: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
